const makeSchema = (article) => {
  return {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: article.title,
    image: [article?.image],
    datePublished: article.createdAt,
    dateModified: article.createdAt,
    author: [
      {
        "@type": "Person",
        name: article.name,
        url: article.userImage,
      },
    ],
  };
};
const ArticleSchema = (article, id) => {
  return (
    <script
      key={`jobJSON-${id}`}
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(makeSchema(article)) }}
    />
  );
};

export default ArticleSchema;
